<script setup>
import { computed, onBeforeMount, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import SidenavItem from "./SidenavItem.vue";
import Menu from '@/layouts/admin/menu/Menu.vue';

import { useUiStore } from '@/store/uiStore';
import { useMenuStore } from '@/store/modules/menuStore';

const ui = useUiStore();
const menuStore = useMenuStore();

const isRTL = computed(() => ui.isRTL);
const menus = computed(() => menuStore.flatMenus);

const route = useRoute();
const getRoute = () => route.path.split("/")[1];

const seccionesAbiertas = ref([]);

onBeforeMount(async () => {
  const token = sessionStorage.getItem("token");
  if (!token) return;

  if (!menus.value.length) {
    await menuStore.loadMenus();
  }
});

onMounted(() => {
  const grupos = Object.values(menus.value);

  seccionesAbiertas.value = grupos
    .map((grupo, index) => {
      if (!Array.isArray(grupo)) {
        console.warn(`❌ El grupo en el índice ${index} NO es un array:`, grupo);
        return null;
      }

      const activa = grupo.some(menu => getRoute() === menu.adme_ruta);
      return activa ? index : null;
    })
    .filter(i => i !== null);
});

</script>
<template>
  <div class="collapse navbar-collapse w-auto h-100 overflow-x-hidden" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item to="/dashboard-default" :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          :navText="isRTL ? 'لوحة القيادة' : 'Dashboard'">
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
    <Menu></Menu>
   <!--  <ul class="navbar-nav">
      <li class="mt-3 nav-item">
        <h6 v-if="isRTL" class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
          :class="isRTL ? 'me-4' : 'ms-2'">
          صفحات المرافق
        </h6>

        <h6 v-else class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6" :class="isRTL ? 'me-4' : 'ms-2'">
          ACCOUNT PAGES
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-item to="/profile" :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="isRTL ? 'حساب تعريفي' : 'Profile'">
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>


      <li class="nav-item">
        <sidenav-item to="/tables" :class="getRoute() === 'tables' ? 'active' : ''"
          :navText="isRTL ? 'الجداول' : 'Tables'">
          <template v-slot:icon>
            <i class="ni ni-calendar-grid-58 text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item to="/" :class="getRoute() === 'billing' ? 'active' : ''"
          :navText="isRTL ? 'الفواتیر' : 'Billing'">
          <template v-slot:icon>
            <i class="ni ni-credit-card text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item to="/signin" :class="getRoute() === 'signin' ? 'active' : ''"
          :navText="isRTL ? 'تسجيل الدخول' : 'Sign In'">
          <template v-slot:icon>
            <i class="ni ni-single-copy-04 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item to="/signup" :class="getRoute() === 'signup' ? 'active' : ''"
          :navText="isRTL ? 'اشتراك' : 'Sign Up'">
          <template v-slot:icon>
            <i class="ni ni-collection text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul> -->

  </div>
</template>
